import { useContext } from "react"
import { ReportFiltersContext } from "../../contexts/ReportFiltersContext.context"

const useReportFiltersContext = () => {
  const data = useContext(ReportFiltersContext)
  return data
}

export default useReportFiltersContext
